import { Icon } from '@iconify/react';
import { Navigate, useRoutes } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useRef, useState, useEffect } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { Link as RouterLink } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import file from '@iconify/icons-eva/file-outline';
import activity from '@iconify/icons-eva/activity-outline';
import reset from '@iconify/icons-eva/person-remove-outline';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, Modal, Box, Typography } from '@mui/material';
import { connect } from 'react-redux';


// ----------------------------------------------------------------------

MoreMenu.propTypes = {
  userObject: PropTypes.object,
  isTrue:PropTypes.bool,
  handleClick:PropTypes.func
};

function MoreMenu(props) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>
      {
        props.isCarMenu &&
        <Menu
          open={isOpen}
          anchorEl={ref.current}
          onClose={() => setIsOpen(false)}
          PaperProps={{
            sx: { width: 200, maxWidth: '100%' }
          }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
          <MenuItem sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={file} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="view car detail" primaryTypographyProps={{ variant: 'body2' }} onClick={() => {props.handleCarDetail();setIsOpen(false);}}/>
          </MenuItem>
          {
            _.isEmpty(props.car.proforma_invoice) &&
            <MenuItem sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon icon={file} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="proforma invoice" primaryTypographyProps={{ variant: 'body2' }} onClick={() => {props.handleOpenInvoice();setIsOpen(false);}} />
            </MenuItem>
          }
          {
            _.isEmpty(props.car.agreement) &&
            <MenuItem sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon icon={file} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="create agreement" primaryTypographyProps={{ variant: 'body2' }} onClick={() => {props.handleOpenAgreement();setIsOpen(false);}} />
            </MenuItem>
          }
          {
            _.isEmpty(props.car.reprocessing) &&
            <MenuItem sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon icon={file} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="re processing plan" primaryTypographyProps={{ variant: 'body2' }} onClick={() => {props.handleOpenReProcessingForm();setIsOpen(false);}} />
            </MenuItem>
          }
        </Menu>
      }
      {
        props.isAgreementMenu &&
        <Menu
          open={isOpen}
          anchorEl={ref.current}
          onClose={() => setIsOpen(false)}
          PaperProps={{
            sx: { width: 200, maxWidth: '100%', }
          }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        { _.isEmpty(props.agreement.installment_plan) &&
          <MenuItem sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={file} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="create installment" primaryTypographyProps={{ variant: 'body2' }} onClick={() => {props.hanldeInstallmentClick();setIsOpen(false);}} />
          </MenuItem>
        }
        </Menu>
      }
    </>
  );
}
const mapStateToProps = (state) => {
    return {
      auth: state.auth,
      alerts: state.alerts,
      agreements: Object.values(state.agreements.data),
      proformaInvoices: Object.values(state.proformaInvoices.data),
    }
}

export default connect(mapStateToProps, {  })(MoreMenu);
